import {Anchor, Center, Group, Image, Menu, Popover, Stack, UnstyledButton} from "@mantine/core";
import MainMenu, { MainMenuItem } from "./MainMenu";

import Icon from "./Icon";
import { Link } from "react-router-dom";
import { useState } from "react";
import SideBarDropDown from "./SidebarDropdown";
import { connect } from "react-redux";
import { useDisclosure } from "@mantine/hooks";
import { resetData } from "../../../redux/action/General/generalActions";
import { useEffect } from "react";
import TenantPortalLogo from "../../../assests/svg/TenantPortalLogo.svg";

const AppSidebar = (props) => {
  const [hover, setHover] = useState(false);
  const [opened, { close, open }] = useDisclosure(false);
  const [enableCompanyLogo, setEnableCompanyLogo] = useState(props?.account?.logoPreference === 'UserDefined' && props?.account?.pictureLocation)
  const handleLogout = () => {
    localStorage.clear();
    props.resetData();
    window.location.href = "/login";
  }

  useEffect(()=>{
    setEnableCompanyLogo(props?.account?.logoPreference === 'UserDefined' && props?.account?.pictureLocation);
  }, [props?.account?.logoPreference, props?.account?.pictureLocation])

  return (
    <Stack 
      spacing="md"
      justify="space-between"
      sx={{ 
        height: '100vh', 
        paddingBottom: 16,
        position: "sticky",
        top: 0,
        bottom: 0,
        minWidth: '54px'
      }}
    >

      {/* Main options and menu */}
      <Stack>
        {!props.isTablet &&
        <>
          <Center pt={24} pb={12}>
            <Anchor href="/">
              <Stack align={'center'} spacing={7} >
                <Image 
                src={enableCompanyLogo ? props.account.pictureLocation : `/hello-housing-logo.svg`} 
                withPlaceholder 
                height={enableCompanyLogo && 80} 
                radius={'md'}/>
                {enableCompanyLogo && 
                <Image 
                src={TenantPortalLogo} 
                withPlaceholder 
                width={103}/>}
              </Stack>
            </Anchor>
          </Center>
          <SideBarDropDown/>
        </>}
        <MainMenu/>
      </Stack>
      <Stack spacing={6}>
        <MainMenuItem icon="user" route={'/profile'}>{!props.isTablet && 'Profil'}</MainMenuItem>
        <Group onClick={handleLogout}><MainMenuItem icon="logout" color="red">{!props.isTablet && 'Abmelden'}</MainMenuItem></Group>
      </Stack>
      {/* <Menu trigger="hover" openDelay={100} closeDelay={200} width={'target'}>
        <Menu.Target>
          <div><MainMenuItem icon="user" route={'/profile'}>{!props.isTablet && 'Konto'}</MainMenuItem></div>
        </Menu.Target>
        <Menu.Dropdown>
            <MainMenuItem icon="user" route={'/profile'}>{!props.isTablet && 'Profil'}</MainMenuItem>
            <Group onClick={handleLogout}><MainMenuItem icon="logout" color="red">{!props.isTablet && 'Abmelden'}</MainMenuItem></Group>
        </Menu.Dropdown>
      </Menu> */}
    </Stack>
  )
}

const mapStateToProps = (state) => {
  return {
    account: state.generalReducer.accountData,
    profile: state.generalReducer.profileData,
    property: state.generalReducer.propertyData,
    isMobile: state.generalReducer.isMobile,
    isTablet: state.generalReducer.isTablet,
  };
};

const actions = {
  resetData
}

export default connect(mapStateToProps, actions)(AppSidebar);